import { ComingNomenclatureFare, ComingNomenclatureSalaryRequest } from 'bus/comingNomenclatureMain/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import { DriverPumpSalaryItem, DriverPumpSalaryItemCreate } from './types';

const driverPumpSalary = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriverPumpSalary: builder.query<DriverPumpSalaryItem, PayloadRequest>({
      query: () => ({
        url: '/v1/DriverPumpSalary/configuration',
      }),
    }),
    getDriverPumpSalaryDetail: builder.query<DriverPumpSalaryItemCreate, PayloadRequest>({
      query: (data) => ({
        url: `/v1/DriverPumpSalary/configuration/${data.id}`,
      }),
    }),
    changeDriverPumpSalary: builder.mutation<void, DriverPumpSalaryItemCreate>({
      query: (data) => ({
        url: `/v1/DriverPumpSalary/configuration/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createDriverPumpSalary: builder.mutation<void, DriverPumpSalaryItemCreate>({
      query: (data) => ({
        url: '/v1/DriverPumpSalary/configuration',
        method: 'POST',
        body: data,
      }),
    }),
    deleteDriverPumpSalary: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/DriverPumpSalary/configuration/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getDriverPumpSalaryDetails: builder.query<ComingNomenclatureFare, ComingNomenclatureSalaryRequest>({
      query: (data) => ({
        url: `/v1/driverPumpSalary/${data.driverId}/details`,
        params: data,
      }),
    }),
  }),
});

export const {
  useChangeDriverPumpSalaryMutation,
  useCreateDriverPumpSalaryMutation,
  useGetDriverPumpSalaryDetailQuery,
  useGetDriverPumpSalaryQuery,
  useLazyGetDriverPumpSalaryDetailQuery,
  useLazyGetDriverPumpSalaryQuery,
  useDeleteDriverPumpSalaryMutation,
  useLazyGetDriverPumpSalaryDetailsQuery,
  useGetDriverPumpSalaryDetailsQuery,
} = driverPumpSalary;
